
import { darkTheme as config } from './config';
import { styles } from './styles';
import { BackgroundEffects, TypingIndicator } from './components';

export default {
  config,
  styles,
  components: {
    BackgroundEffects,
    TypingIndicator
  }
}; 